import React, { Component } from 'react';
import { connect } from 'react-redux';

import SearchTraining from "../SearchTraining";
import MarketingListItem from "../MarketingListItem";

import * as marketingActions from '../../actions/marketingPage';

class MarketingList extends Component {
    componentDidMount() {
        this.props.getMarketingList();
    }

    render(){

        return (
            <div>
                <SearchTraining
                    label="Add Course or Event..."
                    placeholder="Start typing to search..."
                    disabled={this.props.marketingList.length >= 6}
                    onSelectResult={selected => this.props.addItem(selected)}
                />
                <div className="marketing-list--container">
                    {this.props.marketingList.map(listItem => (
                        <MarketingListItem
                            key={listItem.id}
                            id={listItem.marketable.id}
                            item={listItem}
                            allItems={this.props.marketingList}
                        />
                    ))}
                </div>
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        marketingList: state.marketingPage.marketingList
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addItem(selected){
            dispatch(marketingActions.addMarketingListItem(selected));
        },
        getMarketingList(){
            dispatch(marketingActions.getMarketingList());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MarketingList);


// WEBPACK FOOTER //
// ./components/MarketingList/index.js